import { useState, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import MonitorIcon from '@mui/icons-material/Monitor';
import TitleBar from '../../components/uiParts/TitleBar';
import MenuIcon from '../../components/uiParts/MenuIcon';
import { useAuth } from '../../contexts/AuthContext';

const SignageMenu = () => {
    
    const { authInfo } = useAuth();
    const navigate = useNavigate();

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const loginUserId    = authInfo.userId;
    const loginUserName  = authInfo.userName;
    const lobinAuthority = authInfo.authority;
    
    //-----------------------------------------------
    // useLayoutEffect - iPad Safari 初回レンダリング対策
    // 描画前に同期実行されるため、ブラウザは ready=true の状態のみを描画する
    //-----------------------------------------------
    const [ready, setReady] = useState(false);
    useLayoutEffect(() => {
        setReady(true);
    }, []);
	//===============================================
	// イベントハンドラ
	//===============================================
    const handleClick = (url) => {
        navigate(url);
    };
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    if (!ready) return null;
    return (
        <>
        <Header loginInfo="on" backButton="on" backPage="/home" setEntryDate={handleChange_entryDate} />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                <div>
                    <TitleBar title="サイネージメニュー" />
                    {/*
                    <MenuIcon header="Signage Menu" title="水揚モニター"  onClick={() => handleClick('/unloadMonitor')}>
                        <MonitorIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    */}
                    <MenuIcon header="Signage Menu" title="入札モニター"  onClick={() => handleClick('/bidListMonitor')}>
                        <MonitorIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Signage Menu" title="落札モニター"  onClick={() => handleClick('/bidHistoryMonitor')}>
                        <MonitorIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Signage Menu" title="活魚水槽モニター"  onClick={() => handleClick('/tankListMonitor?tankType=1')}>
                        <MonitorIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Signage Menu" title="鮮魚水槽モニター"  onClick={() => handleClick('/tankListMonitor?tankType=0')}>
                        <MonitorIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
            </div>
        </>
    )
}
export default SignageMenu;